import { API } from "@/lib/api";

export const stripTags = (text) => text.replace(/\s*\[\[[a-z0-9-]+\]\]/g, "").replace(/\*\*/g, "");
export const historyMessage = (message) => ({ id: message.id || crypto.randomUUID(), role: message.role,
  complete: true,
  text: message.content, products: (message.products || []).slice(0, 3), model: message.model || null });

export const applyChatEvent = (message, event) => {
  switch (event.type) {
    case "model": return { ...message, model: event.model };
    case "delta": return { ...message, text: message.text + event.text, pending: false };
    case "done": return { ...message, complete: true, text: event.text ?? message.text, products: (event.products || []).slice(0, 3), model: event.model, pending: false };
    case "error": return { ...message, text: event.message, pending: false, error: true };
    default: return message;
  }
};

export const streamChat = async (payload, signal, onEvent) => {
  const response = await fetch(`${API}/ai/chat`, { method: "POST", credentials: "include", signal,
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(typeof data.detail === "string" ? data.detail : "Chat is unavailable. Please try again.");
  }
  if (!response.body) throw new Error("Chat is unavailable. Please try again.");
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "", complete = false;
  const consume = (part) => {
    if (!part.startsWith("data: ")) return;
    const event = JSON.parse(part.slice(6));
    onEvent(event);
    if (["done", "error"].includes(event.type)) complete = true;
  };
  try {
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n"); buffer = parts.pop(); parts.forEach(consume);
    }
    if (buffer.trim()) consume(buffer);
    if (!complete) throw new Error("The reply was interrupted. Please try again.");
  } finally { reader.releaseLock(); }
};